import { bind } from '@react-rxjs/core';
import {
  catchError,
  filter,
  map,
  merge,
  of,
  scan,
  shareReplay,
  startWith,
  switchMap,
} from 'rxjs';
import { queueNotice } from '../components/Notice';
import {
  login$,
  logoutRequest$,
  sessionExpired$,
} from '../pages/Login/useLogin';
import { convertToAsyncTaskState } from '../utils/rxjs/task';
import { request } from './request';

export type AssignationSource =
  | 'MANUAL'
  | 'IBUTTON'
  | 'TACHO'
  | 'WIRELESS'
  | 'UNKNOWN';

export type Assignation = {
  objectId: number;
  busy: boolean;
  source: AssignationSource;
  state: string;
};

export type Driver = {
  id: number;
  firstName: string;
  lastName: string;
  clientId: number;
  contactInfo?: { address: string; phone: string };
  creationSource: string;
  assignation?: Assignation;
  features: string[];
};

export const driverInfo = () => request<Driver>('/gateway/auth/users/current');

export const driver$ = merge(
  login$.pipe(
    filter(({ result }) => !!result),
    startWith(null),
    scan((acc) => acc + 1, 0),
    switchMap((runNr) =>
      driverInfo().pipe(
        catchError(() => {
          /** dont show this error when user first comes to the page */
          if (runNr > 1) {
            queueNotice({ message: 'Login.Error' });
          }
          return of(null);
        })
      )
    )
  ),
  sessionExpired$.pipe(map(() => null)),
  logoutRequest$
).pipe(shareReplay({ refCount: true, bufferSize: 1 }));

export const [useDriver] = bind(driver$.pipe(convertToAsyncTaskState()), {
  running: false,
  result: null,
  error: null,
});
